import axios from "axios";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";

export default function useCreateAppNotification() {
  const { config, user, providerId } = useContext(LoginContext);

  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      const { notification, fData, sliderData } = payload; // fData = FormData for attachment
      const notifBody = notification.notification;

      notifBody.providerId = providerId;

      const formData = new FormData();

      formData.append("ProviderId", notifBody.providerId);
      formData.append("Title", notifBody.title);
      formData.append("Summary", notifBody.summary || "");
      formData.append("Content", notifBody.content);
      formData.append("Tag", notifBody.tag || "");
      formData.append("CoverImage", notifBody.coverImage || "");
      formData.append("ReadTime", notifBody.readTime || 0);
      formData.append("IsScheduled", notifBody.isScheduled);
      formData.append("notificationType", notifBody.notificationType);
      // formData.append("SendDate", notifBody.sendDate?.toISOString());
      const formattedSendDate = notifBody.sendDate
        ? (
          notifBody.sendDate instanceof Date
            ? notifBody.sendDate
            : new Date(notifBody.sendDate)
        ).toISOString()
        : null;

      formData.append("SendDate", formattedSendDate);

      // append images
      if (fData) {
        for (let pair of sliderData.entries()) {
          formData.append("Images", pair[1]); //backend property name
        }
      }

      const res = await axios.post(
        `${config.api}/api/Notification/GlobalNotification`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const notificationId = res?.data?.globalNotificationId;

      // 2 If NO attachment → stop here and return first response
      if (!fData || fData.entries().next().done) {
        console.log("No attachment present → Skipping attachment API");
        return res.data;
      }

      // 3 If attachment exists → call attachment API
      const attachRes = await axios.post(
        `${config.api}/api/Attachment/globalNotificationAttachment/${notificationId}`,
        fData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return {
        notification: res.data,
        attachment: attachRes.data,
      };
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("Notification");
      },
    }
  );
}
